import * as React from "react";
import { Platform, Text } from "react-native";
import Animated, { FadeIn } from "react-native-reanimated";
import { SafeAreaView } from "react-native-safe-area-context";
import { Redirect, Slot, Stack, usePathname } from "expo-router";
import { StatusBar } from "expo-status-bar";

import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import Logo from "~/assets/logo.svg";
import { useSessionContext } from "~/lib/supabase";
import { GlobalStoreProvider, useGlobalStore } from "~/stores/global";

export default function AppGroupLayout() {
  const { session, isLoading } = useSessionContext();
  const pathname = usePathname();

  if (isLoading) return null;

  if (!session && !pathname.startsWith("/auth")) {
    return <Redirect href="/auth/login" />;
  }

  return (
    <GlobalStoreProvider>
      <EnsureAccount>
        <ResponsiveRenderer
          webDesktop={<Slot />}
          default={
            <>
              <StatusBar />

              <Stack
                screenOptions={{
                  headerBackButtonMenuEnabled: false,
                  headerShadowVisible: Platform.OS !== "web",
                  animation: "fade",
                }}
              >
                <Stack.Screen
                  name="index"
                  options={{ headerShown: false, animation: "fade" }}
                />
                <Stack.Screen
                  name="[account]"
                  options={{ headerShown: false, animation: "fade" }}
                />
                <Stack.Screen
                  name="create-account/index"
                  options={{ animation: "fade" }}
                />
              </Stack>
            </>
          }
        />
      </EnsureAccount>
    </GlobalStoreProvider>
  );
}

function EnsureAccount(props: { children: React.ReactNode }) {
  const storeContext = useGlobalStore();
  const pathname = usePathname();

  if (storeContext.loading) return <StoreLoadingScreen />;

  if (storeContext.error)
    return <StoreLoadingScreen error={storeContext.error} />;

  if (
    !storeContext.store.personalAccount &&
    !pathname.startsWith("/create-account")
  )
    return <Redirect href="/create-account/" />;

  return props.children;
}

function StoreLoadingScreen(_props: { error?: Error }) {
  return (
    <SafeAreaView className="h-screen items-center justify-center">
      <Animated.View entering={FadeIn.delay(150)} className="items-center">
        <Logo className="mx-auto my-2 size-10" />
        <Text className="text-text-primary text-28 font-semibold">
          Loading account...
        </Text>
      </Animated.View>
    </SafeAreaView>
  );
}
